import { render } from "./TrainingItem.vue?vue&type=template&id=1525a848&scoped=true"
import script from "./TrainingItem.vue?vue&type=script&lang=js"
export * from "./TrainingItem.vue?vue&type=script&lang=js"

import "./TrainingItem.vue?vue&type=style&index=0&id=1525a848&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1525a848"]])

export default __exports__